<template>
  <v-container fluid>
    <v-row class="mx-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Empresa
      </div>

      <v-progress-circular
        v-show="!loaded"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <v-spacer></v-spacer>

      <v-btn
        outlined
        text
        class="primary"
        dark
        :disabled="saving"
        @click="save"
      >
        <span v-show="!saving">Salvar</span>
        <v-progress-circular
          v-show="saving"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-btn>
    </v-row>

    <v-container style="max-width: 1800px" v-if="loaded">
      <v-card>
        <v-toolbar color="primary" dark>
          Dados da empresa
          <v-spacer></v-spacer>
        </v-toolbar>

        <!-- <v-container  style="background-color:red;max-width:90%;"  > -->
        <v-container style="max-width: 90%">
          <!-- <v-row style="background-color:green" > -->
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Nome"
                hide-details="auto"
                v-model="enterprise.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Email padrão"
                hide-details="auto"
                v-model="enterprise.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <autocomplete-city
                @changed="changedCity"
                :preSearch="enterprise.cityName"
              ></autocomplete-city>
              <!-- <v-autocomplete
                v-model="enterprise.cityName"
                :loading="loading"
                :items="items"
                :searchCity-input.sync="searchCity"
                cache-items
                flat
                hide-no-data
                hide-details
                label="Cidade"
              ></v-autocomplete> -->
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                label="CEP"
                hide-details="auto"
                v-model="enterprise.zipCode"
                @blur="updatedZipCode"
                v-mask="'##.###-###'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Endereço"
                hide-details="auto"
                v-model="enterprise.streetAddress"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                label="Número"
                hide-details="auto"
                v-model="enterprise.streetAddressNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Complemento"
                hide-details="auto"
                v-model="enterprise.streetAddressNumber2"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Bairro"
                hide-details="auto"
                v-model="enterprise.neighborhood"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="CNPJ"
                hide-details="auto"
                v-model="enterprise.cnpj"
                v-mask="'##.###.###/####-##'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="I.E."
                hide-details="auto"
                v-model="enterprise.ie"
                v-mask="'###.###.###.###'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Fone"
                hide-details="auto"
                v-model="enterprise.phone"
                v-mask="
                  enterprise.phone.length <= 13
                    ? '(##)####-####'
                    : '(##)#####-####'
                "
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-spacer></v-spacer>
            <!-- <v-btn outlined text class="primary" dark> Salvar </v-btn> -->
          </v-row>

          <br />
        </v-container>
      </v-card>
    </v-container>

    <!-- <users-card :users="users" v-if="loaded"></users-card> -->
    <!-- <default-settings-card :defaultSettings = "enterprise.defaultSettings" :services="services"></default-settings-card>  -->

    <v-container style="max-width: 1800px" v-if="enterprise.style">
      <v-card>
        <v-toolbar class="primary" dark> Configurações de aparência </v-toolbar>

        <v-container style="max-width: 90%" class="mt-4">
          <v-row>
            <v-col class="shrink" cols="12" md="2">
              <p class="ma-4">Cor principal</p>
            </v-col>
            <v-col class="shrink" style="min-width: 220px">
              <v-text-field
                v-model="color"
                v-mask="mask"
                hide-details
                class="ma-0 pa-0"
                solo
              >
                <template v-slot:append>
                  <v-menu
                    v-model="menu"
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div :style="swatchStyle" v-on="on" />
                    </template>
                    <v-card>
                      <v-card-text class="pa-0">
                        <v-color-picker v-model="color" flat />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
            </v-col>

            <v-col class="shrink" cols="12" md="2">
              <p class="ma-4">Cor secundária</p>
            </v-col>
            <v-col class="shrink" style="min-width: 220px">
              <v-text-field
                v-model="color2"
                v-mask="mask"
                hide-details
                class="ma-0 pa-0"
                solo
              >
                <template v-slot:append>
                  <v-menu
                    v-model="menu2"
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div :style="swatchStyle2" v-on="on" />
                    </template>
                    <v-card>
                      <v-card-text class="pa-0">
                        <v-color-picker v-model="color2" flat />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="modeAdmin">
            <v-col cols="12" md="10">
              <v-text-field
                label="Imagem logo"
                @change="changeImage"
                v-model="enterprise.style.images.logo"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2"
              ><v-img :src="enterprise.style.images.logo"></v-img>
            </v-col>
          </v-row>

          <v-row v-if="modeAdmin">
            <v-col cols="12" md="10">
              <v-text-field
                label="Imagem logo branco"
                @change="changeImage"
                v-model="enterprise.style.images.logoWhite"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="2"
              ><v-img
                :src="enterprise.style.images.logoWhite"
                style="background-color: gray"
              ></v-img>
            </v-col>
          </v-row>

          <v-row v-if="enterprise.style && enterprise.style.deals">
            <v-col>
              <v-text-field
                label="Nome de negócio singular"
                v-model="enterprise.style.deals.label.singular"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Nome de negócio plural"
                v-model="enterprise.style.deals.label.plural"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <quote-profiles-card
      v-if="modeAdmin"
      :quoteProfiles="enterprise.quoteProfiles"
      :services="services"
      :fields="fields"
    ></quote-profiles-card>
  </v-container>
  <!-- </v-card> -->
</template>

<script>
import cityNames from "@/libraries/data/cityNames.js";
import defaultFields from "@/libraries/data/fields.js";

import VComponent from "../../../../components/base/VComponent.vue";

import DefaultSettingsCard from "@/views/dashboard/components/cards/DefaultSettingsCard";
import QuoteProfilesCard from "@/views/dashboard/components/cards/QuoteProfilesCard";
import hebelApi from "../../../../libraries/hebel/hebelApi";
import AutocompleteCity from "../../component/AutocompleteCity.vue";
import UsersCard from "../../components/cards/UsersCard.vue"

export default {
  components: {
    DefaultSettingsCard,
    QuoteProfilesCard,
    AutocompleteCity,
    UsersCard
  },
  name: "Home",

  data() {
    return {
      loading: false,
      items: [],
      searchCity: null,
      select: null,
      enterprise: {},
      services: [],
      fields: [],
      saving: false,
      color: "#000000",
      mask: "XXXXXXX",
      menu: false,
      color2: "#000000",
      mask2: "XXXXXXX",
      menu2: false,
      loaded: false,
      users:[],
      profiles:[
                {
                  id:'admin',
                  name:'Administrador',
                  access:{
                          appearance:true,
                          enterprise:true,
                          products:true,
                          fields:true,
                          allContacts:true, //False == only owner,
                          efficiency:true,
                          unitCost:true,
                          unitPrice:true,
                          discount:true
                  }
                },
                {
                  id:'seller',
                  name:'Vendedor',
                  access:{
                          appearance:false,
                          enterprise:false,
                          products:false,
                          fields:false,
                          allContacts:false, //False == only owner,
                          efficiency:false,
                          unitCost:false,
                          unitPrice:false,
                          discount:false
                  }
                }
      
      ],
      profileId:''
    };
  },
  computed: {
    modeAdmin: function () {
      return (
        process.env.NODE_ENV === "development" ||
        window.eid == "EFZwxQvKjmt6Bn4ZlzCg"
      );
    },
    swatchStyle() {
      const { color, menu } = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    swatchStyle2() {
      const { color2, menu2 } = this;
      return {
        backgroundColor: color2,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu2 ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
  async mounted() {
    //alert(window.uid)
    //Load user informations
    //var enterprise = await this.$dao.getEnterprise(window.eid);
    var enterprise = await hebelApi.enterprises.getFromId(window.eid);
    //Users
    this.users = await  hebelApi.users.getAllFromEntepriseId(window.eid)

    //Load profiles

    for (var u =0 ; u < this.users.length; u++){
      if (!this.users[u].profile){
          this.users[u].profile = this.profiles[0];
          this.users[u].profileId = this.profiles[0].id;
      }
    }


    if (!enterprise.defaultSettings) {
      enterprise.defaultSettings = { services: [] };
    }

    if (!enterprise.quoteProfiles) {
      enterprise.quoteProfiles = [];

      var quoteProfile = {
        description: "Completo",
        // services:[
        //             {serviceId:"", priceFormula:"", costFormula:"", quantityFormula:"" },
        //             {serviceId:"", priceFormula:"", costFormula:"", quantityFormula:"" }
        // ],
        // fields:[
        //           {fieldId:"", formula:""},
        //           {fieldId:"", formula:""},
        // ],
        formula: {
          script: "",
          fields: [
            //   {  name: "", id:null, type: "", object :"quote", dafault : true},
          ],
        },
      };

      enterprise.quoteProfiles.push(quoteProfile);
    }
    //Temp
    for (var q = 0; q < enterprise.quoteProfiles.length; q++) {
      if (!enterprise.quoteProfiles[q].formulaDocument)
        enterprise.quoteProfiles[q].formulaDocument = {
          script: "",
          fields: [],
          images: [],
        };

      if (!enterprise.quoteProfiles[q].formulaServices)
        enterprise.quoteProfiles[q].formulaServices = {
          script: "",
          fields: [],
        };

      if (!enterprise.quoteProfiles[q].formulaProducts)
        enterprise.quoteProfiles[q].formulaProducts = {
          script: "",
          fields: [],
        };

      if (!enterprise.quoteProfiles[q].services)
        enterprise.quoteProfiles[q].services = [];
      if (!enterprise.quoteProfiles[q].products)
        enterprise.quoteProfiles[q].products = [];

      if (!enterprise.quoteProfiles[q].devicesOptions)
        enterprise.quoteProfiles[q].devicesOptions = {
          stringbox: { enabled: true, formula: "" },
          transformer: { enabled: true, formula: "" },
          structure: { enabled: true, formula: "" },
        };
    }

    this.enterprise = enterprise;
    //this.services = await this.$dao.getDevices(window.eid, "*", "service");
    this.services = await hebelApi.devices.getAll("*", "service");

    //this.fields = await this.$dao.getFields(window.eid);
    this.fields = await hebelApi.fields.getAll();

    //alert(JSON.stringify(defaultFields))
    this.fields = defaultFields.concat(this.fields);
    if (!enterprise.style) {
      enterprise.style = {
        primary: this.$vuetify.theme.themes.light.primary,
        secondary: this.$vuetify.theme.themes.light.primary,
      };
    }
    if (!enterprise.style.images) {
      enterprise.style.images = {
        logo: "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoDark.png?alt=media&token=1f1ccfdd-f077-4ce9-8d33-0aa6aca10fa7",
        logoWhite:
          "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoWhite.png?alt=media&token=ee04c64c-4ab6-454d-8152-970016298a6a",
      };
    }
    if (!enterprise.style.deals) {
      enterprise.style.deals = {
        label: {
          singular: "Negócio",
          plural: "Negócios",
        },
      };
    }
    this.color = this.enterprise.style.primary;
    this.color2 = this.enterprise.style.secondary;
    // alert(this.color)
    // this.select = this.enterprise.cityName;
    this.searchCity = this.enterprise.cityName;
    //this.cities = cityNames;

    this.loaded = true;
    
    },
  watch: {
    searchCity(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  methods: {
    changedCity(cityName) {
      this.enterprise.cityName = cityName;
    },
    async test() {
      //alert("test")

      //var mods = await hebelApi.getAllModules(window.eid)

      var mods = await hebelApi.deals.otherMethod();
      alert(JSON.stringify(mods));
    },

    async updatedZipCode() {
      var info = await this.$globalFunctions.searchZipCode(
        this.enterprise.zipCode
      );
      this.search = info.cityName;
      this.enterprise.cityName = info.cityName;
      this.enterprise.streetAddress = info.streetAddress;
      this.enterprise.neighborhood = info.neighborhood;
    },

    changeImage() {
      //  alert("update");
      this.$forceUpdate();
    },
    async save() {
      this.enterprise.style.primary = this.color;
      this.enterprise.style.secondary = this.color2;

      this.$vuetify.theme.themes.light.primary = this.color;
      this.$vuetify.theme.themes.light.secondary = this.color2;

      //Save enterprise
      console.log("save");
      this.saving = true;
      //var ans = await this.$dao.saveEnterprise(this.enterprise);
      var ans = await hebelApi.enterprises.patch(this.enterprise);

      this.$session.set("images", this.enterprise.style.images);

      this.$forceUpdate();
      this.dialog = false;
      this.saving = false;
    },

    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        this.items = cityNames.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },

    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },

    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
.labelValue {
  display: block;
  width: 120px;
  margin: auto;
  text-align: center;
}
.cardLabel {
  position: absolute;
  right: 10px;
  top: 20px;
  height: 60px;
  width: 240px;
  background-color: #4c6563;
  border-radius: 15px;
}
table {
  border: none !important;
}
</style>
